export default __webpack_public_path__ + "static/media/lounge.25623bcf.jpg";